(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-discount"] && !Shopify.designMode) return;
  try {
    (function () {
    function t(root, key) {
      return root.getAttribute('data-i18n-' + key) || '';
    }

    function showError(root, msg) {
      var el = root.querySelector('[data-cart-discount-error]');
      if (!el) return;
      el.textContent = msg;
      el.removeAttribute('hidden');
    }

    function clearError(root) {
      var el = root.querySelector('[data-cart-discount-error]');
      if (!el) return;
      el.textContent = '';
      el.setAttribute('hidden', '');
    }

    function applyCode(root, code) {
      if (!code) return;
      var submit = root.querySelector('[data-cart-discount-submit]');
      if (submit) {
        if (!submit.getAttribute('data-original-text')) {
          submit.setAttribute('data-original-text', submit.textContent.trim());
        }
        submit.disabled = true;
        submit.textContent = t(root, 'applying');
      }
      clearError(root);

      var root_url = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/');
      fetch(root_url + 'discount/' + encodeURIComponent(code), {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Accept': 'application/json' }
      })
        .then(function () { return fetch(root_url + 'cart.js', { headers: { 'Accept': 'application/json' } }); })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var applied = (cart.cart_level_discount_applications || []).some(function (d) {
            return String(d.title).toLowerCase() === code.toLowerCase();
          });
          if (applied) {
            window.location.reload();
            return;
          }
          if (submit) {
            submit.disabled = false;
            submit.textContent = submit.getAttribute('data-original-text') || submit.textContent;
          }
          showError(root, t(root, 'error-invalid'));
        })
        .catch(function () {
          if (submit) {
            submit.disabled = false;
            submit.textContent = submit.getAttribute('data-original-text') || submit.textContent;
          }
          showError(root, t(root, 'error-invalid'));
        });
    }

    function removeCode(root, code) {
      var root_url = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/');
      fetch(root_url + 'cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ discount: '' })
      })
        .then(function (r) {
          if (!r.ok) throw new Error('HTTP ' + r.status);
          window.location.reload();
        })
        .catch(function () {
          showError(root, t(root, 'error-remove'));
        });
    }

    document.addEventListener('submit', function (event) {
      var form = event.target.closest('[data-cart-discount-form]');
      if (!form) return;
      event.preventDefault();
      var root = form.closest('[data-cart-discount]');
      if (!root) return;
      var input = root.querySelector('[data-cart-discount-input]');
      if (!input) return;
      var code = input.value.trim();
      if (!code) {
        showError(root, t(root, 'error-empty'));
        input.focus();
        return;
      }
      form.setAttribute('action', '/discount/' + encodeURIComponent(code));
      applyCode(root, code);
    });

    document.addEventListener('click', function (event) {
      var btn = event.target.closest('[data-cart-discount-remove]');
      if (!btn) return;
      event.preventDefault();
      var root = btn.closest('[data-cart-discount]');
      if (!root) return;
      var code = btn.getAttribute('data-code') || '';
      btn.disabled = true;
      removeCode(root, code);
    });

    if (window.discountError) {
      document.querySelectorAll('[data-cart-discount]').forEach(function (root) {
        showError(root, t(root, 'error-invalid'));
      });
      try { delete window.discountError; } catch (e) { window.discountError = null; }
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cart-note"] && !Shopify.designMode) return;
  try {
    (function () {
    var field = document.querySelector('[data-cart-note-field]');
    var status = document.querySelector('[data-cart-note-status]');
    if (!field) return;

    var root = field.closest('[data-cart-note]') || document;
    var debounceTimer = null;
    var lastSaved = field.value;

    function setStatus(text, kind) {
      if (!status) return;
      status.textContent = text;
      status.classList.remove('is-saved', 'is-error');
      if (kind) status.classList.add('is-' + kind);
    }

    function t(key) {
      return root.getAttribute('data-i18n-' + key) || '';
    }

    function persist() {
      var value = field.value;
      if (value === lastSaved) return;

      if (!window.AlkyraCart) {
        setStatus(t('reload'), 'error');
        return;
      }

      setStatus(t('saving'));

      fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ note: value })
      })
        .then(function (r) {
          if (!r.ok) throw new Error('HTTP ' + r.status);
          return r.json();
        })
        .then(function () {
          lastSaved = value;
          setStatus(t('saved'), 'saved');
        })
        .catch(function () {
          setStatus(t('error'), 'error');
        });
    }

    field.addEventListener('input', function () {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(persist, 600);
    });

    field.addEventListener('blur', function () {
      clearTimeout(debounceTimer);
      persist();
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["free-shipping-bar"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__alkyraFreeShippingBarInit) return;
    window.__alkyraFreeShippingBarInit = true;

    function formatMoney(cents) {
      if (typeof cents !== 'number' || isNaN(cents)) return '';
      var lang = (document.documentElement && document.documentElement.lang) || 'es';
      try {
        return new Intl.NumberFormat(lang, { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(cents / 100) + '€';
      } catch (e) {
        return (cents / 100).toFixed(2) + '€';
      }
    }

    function updateBar(bar, totalCents) {
      var thresholdCents = parseInt(bar.getAttribute('data-threshold-cents'), 10);
      if (isNaN(thresholdCents) || thresholdCents <= 0) return;

      var remaining = Math.max(0, thresholdCents - totalCents);
      var unlocked = remaining === 0;
      var progress = Math.min(100, Math.max(0, (totalCents / thresholdCents) * 100));

      var fill = bar.querySelector('[data-free-shipping-fill]');
      if (fill) fill.style.width = progress + '%';

      bar.classList.toggle('free-shipping-bar--unlocked', unlocked);

      var message = bar.querySelector('[data-free-shipping-message]');
      if (!message) return;

      if (totalCents === 0 && bar.getAttribute('data-intro-text')) {
        message.textContent = bar.getAttribute('data-intro-text');
      } else if (unlocked) {
        message.textContent = bar.getAttribute('data-unlocked-text') || message.textContent;
      } else {
        var template = bar.getAttribute('data-remaining-template');
        if (template) message.textContent = template.replace('%%AMOUNT%%', formatMoney(remaining));
      }
    }

    document.addEventListener('cart:change', function (event) {
      var cart = event.detail && event.detail.cart;
      if (!cart || typeof cart.total_price !== 'number') return;
      document.querySelectorAll('[data-free-shipping-bar]').forEach(function (bar) {
        updateBar(bar, cart.total_price);
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["language-switcher"] && !Shopify.designMode) return;
  try {
    (function () {
  document.querySelectorAll('localization-form').forEach(function (root) {
    var toggle = root.querySelector('[data-lang-toggle]');
    var popover = root.querySelector('[data-lang-popover]');
    if (!toggle || !popover) return;

    function close() {
      popover.hidden = true;
      toggle.setAttribute('aria-expanded', 'false');
    }
    function open() {
      popover.hidden = false;
      toggle.setAttribute('aria-expanded', 'true');
    }

    toggle.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      if (popover.hidden) open(); else close();
    });

    document.addEventListener('click', function (e) {
      if (!root.contains(e.target)) close();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
    });
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["perfume-quiz"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('perfume-quiz')) {
  var FAMILY_MAP = {
    floral: ['floral', 'frutal', 'aldehidica'],
    amaderado: ['amaderada', 'especiada'],
    ambar: ['ambar', 'oriental', 'almizcle', 'vainilla'],
    citrico: ['citrica', 'acuatica'],
    gourmand: ['gourmand', 'vainilla'],
    chipre: ['fougere', 'aromatica', 'chipre']
  };
  var INTENSITY_MAP = {
    bold: ['ambar', 'oriental', 'especiada', 'gourmand', 'vainilla', 'almizcle', 'amaderada', 'fougere'],
    discreet: ['citrica', 'acuatica', 'aromatica', 'floral', 'frutal', 'aldehidica']
  };
  var RESULT_LIMIT = 4;

  function normalize(s) {
    return (s || '')
      .toString()
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .trim();
  }

  function tokenize(s) {
    return normalize(s).split(/[^a-z0-9]+/).filter(function (t) { return t.length > 0; });
  }

  function levenshtein(a, b) {
    if (a === b) return 0;
    if (!a.length) return b.length;
    if (!b.length) return a.length;
    var prev = new Array(b.length + 1);
    var curr = new Array(b.length + 1);
    for (var j = 0; j <= b.length; j++) prev[j] = j;
    for (var i = 1; i <= a.length; i++) {
      curr[0] = i;
      for (j = 1; j <= b.length; j++) {
        var cost = a[i - 1] === b[j - 1] ? 0 : 1;
        curr[j] = Math.min(curr[j - 1] + 1, prev[j] + 1, prev[j - 1] + cost);
      }
      var tmp = prev; prev = curr; curr = tmp;
    }
    return prev[b.length];
  }

  function formatMoney(cents) {
    if (cents == null) return '';
    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      try { return Shopify.formatMoney(cents); } catch (_) { /* fall through */ }
    }
    var currency =
      (window.Shopify && Shopify.currency && Shopify.currency.active) ||
      (window.Shopify && Shopify.shop && Shopify.shop.currency) ||
      'EUR';
    var locale = (document.documentElement && document.documentElement.lang) || 'en';
    try {
      return new Intl.NumberFormat(locale, { style: 'currency', currency: currency }).format(cents / 100);
    } catch (_) {
      return (cents / 100).toFixed(2) + ' ' + currency;
    }
  }

  function scoreText(query, product) {
    if (!query) return 0;
    var q = normalize(query);
    if (!q || !product._inspiredNorm) return 0;
    if (product._inspiredNorm === q) return 1000;
    if (product._inspiredNorm.indexOf(q) !== -1 || q.indexOf(product._inspiredNorm) !== -1) return 700;

    var qTokens = tokenize(q);
    if (!qTokens.length) return 0;
    var matched = 0;
    qTokens.forEach(function (qt) {
      var best = 0;
      product._inspiredTokens.forEach(function (pt) {
        if (pt === qt) { best = Math.max(best, 2); return; }
        if (pt.indexOf(qt) !== -1 || qt.indexOf(pt) !== -1) { best = Math.max(best, 1); return; }
        if (Math.abs(pt.length - qt.length) <= 2 && levenshtein(qt, pt) <= 2) best = Math.max(best, 1);
      });
      matched += best;
    });
    return Math.min(650, matched * 90);
  }

  function scoreProduct(product, state) {
    var score = 0;
    var textScore = scoreText(state.text, product);
    score += textScore;

    if (state.family) {
      var familyWords = FAMILY_MAP[state.family] || [];
      if (product._familiaTokens.some(function (t) { return familyWords.indexOf(t) !== -1; })) {
        score += 300;
      }
    }

    if (state.intensity) {
      var intensityWords = INTENSITY_MAP[state.intensity] || [];
      if (product._familiaTokens.some(function (t) { return intensityWords.indexOf(t) !== -1; })) {
        score += 100;
      }
    }

    return { score: score, exactMatch: textScore >= 700 };
  }

  class PerfumeQuiz extends HTMLElement {
    connectedCallback() {
      this.catalog = this.loadCatalog();
      this.state = { text: '', family: null, intensity: null };
      this.stepLabel = this.querySelector('[data-quiz-step-label]');
      this.matchBadgeText = this.getAttribute('data-match-badge') || '';
      this.stepLabels = {
        '1': this.getAttribute('data-step-label-1') || '',
        '2': this.getAttribute('data-step-label-2') || '',
        '3': this.getAttribute('data-step-label-3') || ''
      };
      this.panels = {};
      const panelEls = this.querySelectorAll('[data-quiz-panel]');
      panelEls.forEach((el) => { this.panels[el.getAttribute('data-quiz-panel')] = el; });
      this.rowsHost = this.querySelector('[data-quiz-rows]');
      this.input = this.querySelector('[data-quiz-input]');

      this.bindEvents();
      this.goTo('1', { focusInput: false });
    }

    loadCatalog() {
      const script = document.getElementById('perfume-quiz-catalog');
      if (!script) return [];
      let raw;
      try {
        raw = JSON.parse(script.textContent || '[]');
      } catch (_) {
        return [];
      }
      if (!Array.isArray(raw)) return [];
      return raw.map((p) => {
        const familiaNorm = normalize(p.familia);
        return {
          id: p.id,
          title: p.title,
          url: p.url,
          image: p.image,
          price_min: typeof p.price_min === 'number' ? p.price_min : null,
          familia: p.familia || '',
          inspired: p.inspired || '',
          _familiaTokens: familiaNorm.split('·').map((t) => t.trim()).filter(Boolean),
          _inspiredNorm: normalize(p.inspired),
          _inspiredTokens: tokenize(p.inspired)
        };
      });
    }

    bindEvents() {
      const nextBtn = this.querySelector('[data-quiz-next]');
      if (nextBtn) {
        nextBtn.addEventListener('click', () => {
          this.state.text = this.input ? this.input.value.trim() : '';
          this.goTo('2');
        });
      }

      if (this.input) {
        this.input.addEventListener('keydown', (e) => {
          if (e.key === 'Enter') {
            e.preventDefault();
            this.state.text = this.input.value.trim();
            this.goTo('2');
          }
        });
      }

      this.querySelectorAll('[data-quiz-back]').forEach((btn) => {
        btn.addEventListener('click', () => this.goTo(btn.getAttribute('data-quiz-back')));
      });

      const familyChips = this.querySelectorAll('[data-quiz-chips="family"] [data-quiz-value]');
      familyChips.forEach((chip) => {
        chip.addEventListener('click', () => {
          familyChips.forEach((c) => c.setAttribute('aria-pressed', 'false'));
          chip.setAttribute('aria-pressed', 'true');
          this.state.family = chip.getAttribute('data-quiz-value');
          this.goTo('3');
        });
      });

      const intensityChips = this.querySelectorAll('[data-quiz-chips="intensity"] [data-quiz-value]');
      intensityChips.forEach((chip) => {
        chip.addEventListener('click', () => {
          intensityChips.forEach((c) => c.setAttribute('aria-pressed', 'false'));
          chip.setAttribute('aria-pressed', 'true');
          this.state.intensity = chip.getAttribute('data-quiz-value');
          this.showResults();
        });
      });

      const restartBtn = this.querySelector('[data-quiz-restart]');
      if (restartBtn) {
        restartBtn.addEventListener('click', () => this.reset());
      }
    }

    goTo(step, options) {
      var focusInput = !options || options.focusInput !== false;
      Object.keys(this.panels).forEach((key) => {
        this.panels[key].hidden = key !== step;
      });
      if (this.stepLabel) {
        this.stepLabel.textContent = this.stepLabels[step] || '';
      }
      if (step === '1' && this.input && focusInput) {
        this.input.focus({ preventScroll: true });
      }
    }

    showResults() {
      let scored = this.catalog
        .map((p) => Object.assign({ product: p }, scoreProduct(p, this.state)))
        .filter((entry) => entry.score > 0)
        .sort((a, b) => b.score - a.score);

      if (!scored.length) {
        scored = this.catalog.slice(0, RESULT_LIMIT).map((p) => ({ product: p, score: 0, exactMatch: false }));
      }

      this.renderRows(scored.slice(0, RESULT_LIMIT));
      this.goTo('results');
    }

    renderRows(entries) {
      if (!this.rowsHost) return;
      this.rowsHost.innerHTML = '';
      const frag = document.createDocumentFragment();

      entries.forEach((entry) => {
        const p = entry.product;
        const row = document.createElement('a');
        row.className = 'perfume-quiz__row';
        row.href = p.url;
        row.setAttribute('data-search-drawer-close', '');

        const thumb = document.createElement('div');
        thumb.className = 'perfume-quiz__row-thumb';
        if (p.image) {
          const img = document.createElement('img');
          img.src = p.image;
          img.alt = p.title || '';
          img.loading = 'lazy';
          thumb.appendChild(img);
        }
        row.appendChild(thumb);

        const meta = document.createElement('div');
        meta.className = 'perfume-quiz__row-meta';

        const titleLine = document.createElement('div');
        titleLine.className = 'perfume-quiz__row-title-line';
        const title = document.createElement('span');
        title.className = 'perfume-quiz__row-title';
        title.textContent = p.inspired ? p.title + ' — ' + p.inspired : p.title;
        titleLine.appendChild(title);
        if (entry.exactMatch && this.matchBadgeText) {
          const badge = document.createElement('span');
          badge.className = 'perfume-quiz__row-badge';
          badge.textContent = this.matchBadgeText;
          titleLine.appendChild(badge);
        }
        meta.appendChild(titleLine);

        if (p.familia) {
          const fam = document.createElement('span');
          fam.className = 'perfume-quiz__row-familia';
          fam.textContent = p.familia;
          meta.appendChild(fam);
        }
        row.appendChild(meta);

        if (p.price_min != null) {
          const price = document.createElement('span');
          price.className = 'perfume-quiz__row-price';
          price.textContent = formatMoney(p.price_min);
          row.appendChild(price);
        }

        frag.appendChild(row);
      });

      this.rowsHost.appendChild(frag);
    }

    reset() {
      this.state = { text: '', family: null, intensity: null };
      if (this.input) this.input.value = '';
      this.querySelectorAll('[data-quiz-value][aria-pressed="true"]').forEach((chip) => {
        chip.setAttribute('aria-pressed', 'false');
      });
      this.goTo('1');
    }
  }

  customElements.define('perfume-quiz', PerfumeQuiz);
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["refill-banner"] && !Shopify.designMode) return;
  try {
    (function () {
  if (typeof window === 'undefined') return;
  var STORAGE_KEY = 'alkyra:refill-banner-dismissed:v1';
  var banner = document.querySelector('[data-refill-banner-close]');
  if (!banner) return;
  var wrap = banner.closest('.refill-banner');
  if (!wrap) return;

  try {
    if (sessionStorage.getItem(STORAGE_KEY) === '1') {
      wrap.classList.add('is-hidden');
      return;
    }
  } catch (e) {}

  banner.addEventListener('click', function () {
    wrap.classList.add('is-hidden');
    try { sessionStorage.setItem(STORAGE_KEY, '1'); } catch (e) {}
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["search-drawer"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('search-drawer')) {
  class SearchDrawer extends HTMLElement {
    constructor() {
      super();
      this.panel = this.querySelector('.search-drawer__panel');
      this.input = this.querySelector('[data-search-drawer-input]');
      this.closeButtons = this.querySelectorAll('[data-search-drawer-close]');
      this.opener = null;
      this.previousFocus = null;
      this.onKeydown = this.onKeydown.bind(this);
    }

    connectedCallback() {
      this.closeButtons.forEach((btn) => {
        btn.addEventListener('click', () => this.close());
      });
    }

    open(opener) {
      if (this.getAttribute('aria-hidden') === 'false') return;

      this.opener = opener || document.activeElement;
      this.previousFocus = document.activeElement;
      this.removeAttribute('hidden');
      document.body.classList.add('search-drawer-open');
      requestAnimationFrame(() => {
        this.setAttribute('aria-hidden', 'false');
        if (this.input) {
          this.input.focus({ preventScroll: true });
          this.input.select();
        }
      });
      document.addEventListener('keydown', this.onKeydown);
    }

    close() {
      if (this.getAttribute('aria-hidden') === 'true') return;

      this.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('search-drawer-open');
      document.removeEventListener('keydown', this.onKeydown);
      const restoreFocus = () => {
        this.setAttribute('hidden', '');
        if (this.opener && typeof this.opener.focus === 'function') {
          this.opener.focus({ preventScroll: true });
        }
      };
      const onEnd = () => {
        this.panel.removeEventListener('transitionend', onEnd);
        restoreFocus();
      };
      this.panel.addEventListener('transitionend', onEnd);
      setTimeout(restoreFocus, 600);
    }

    onKeydown(event) {
      if (event.key === 'Escape') {
        event.preventDefault();
        this.close();
        return;
      }

      if (event.key === 'Tab' && this.panel) {
        const focusables = this.panel.querySelectorAll(
          'a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])'
        );
        if (focusables.length === 0) return;
        const first = focusables[0];
        const last = focusables[focusables.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      }
    }
  }

  customElements.define('search-drawer', SearchDrawer);

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-search-drawer-open]');
    if (!trigger) return;
    event.preventDefault();
    const drawer = document.querySelector('search-drawer');
    if (drawer && typeof drawer.open === 'function') {
      drawer.open(trigger);
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["search-suggest"] && !Shopify.designMode) return;
  try {
    (function () {
  const STOPWORDS = new Set([
    'the', 'and', 'for', 'with', 'eau', 'de', 'parfum', 'ml',
    'el', 'la', 'los', 'las', 'un', 'una', 'y', 'con', 'para', 'del'
  ]);

  function readConfig() {
    const host = document.querySelector('[data-search-suggest-config]');
    if (!host) return null;
    return {
      catalogUrl: host.dataset.catalogUrl || '/collections/all?view=search-catalog',
      searchUrl: host.dataset.searchUrl || '/search',
      minChars: parseInt(host.dataset.minChars || '3', 10),
      limit: parseInt(host.dataset.limit || '24', 10),
      debounce: 200,
    };
  }

  function normalize(s) {
    return (s || '')
      .toString()
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .trim();
  }

  function tokenize(s) {
    return normalize(s).split(/[^a-z0-9]+/).filter(function (t) {
      return t.length >= 2 && !STOPWORDS.has(t);
    });
  }

  function levenshtein(a, b) {
    if (a === b) return 0;
    if (!a.length) return b.length;
    if (!b.length) return a.length;
    let prev = new Array(b.length + 1);
    let curr = new Array(b.length + 1);
    for (let j = 0; j <= b.length; j++) prev[j] = j;
    for (let i = 1; i <= a.length; i++) {
      curr[0] = i;
      for (let j = 1; j <= b.length; j++) {
        const cost = a[i - 1] === b[j - 1] ? 0 : 1;
        curr[j] = Math.min(curr[j - 1] + 1, prev[j] + 1, prev[j - 1] + cost);
      }
      [prev, curr] = [curr, prev];
    }
    return prev[b.length];
  }

  const CACHE_KEY = 'alkyra-search-catalog-v1';
  const CACHE_TTL = 15 * 60 * 1000;

  function parseCatalog(raw) {
    if (!Array.isArray(raw)) return null;
    return raw.map(normalizeProduct).filter(function (p) { return p && p.title; });
  }

  function readCachedCatalog() {
    try {
      const cached = JSON.parse(sessionStorage.getItem(CACHE_KEY) || 'null');
      if (cached && Date.now() - cached.t < CACHE_TTL) return cached.d;
    } catch (_) { /* storage unavailable */ }
    return null;
  }

  function loadCatalog(url) {
    const cached = readCachedCatalog();
    if (cached) return Promise.resolve(parseCatalog(cached));
    return fetch(url, { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : '[]'; })
      .then(function (text) {
        const raw = JSON.parse(text);
        try {
          sessionStorage.setItem(CACHE_KEY, JSON.stringify({ t: Date.now(), d: raw }));
        } catch (_) { /* storage unavailable */ }
        return parseCatalog(raw);
      })
      .catch(function () { return null; });
  }

  function normalizeProduct(p) {
    return {
      id: p.id,
      title: p.title,
      url: p.url,
      vendor: p.vendor || '',
      inspired_by: p.inspired_by || '',
      type: p.type || '',
      image: p.image ? { src: p.image } : null,
      price_min: typeof p.price_min === 'number' ? p.price_min : null,
      _haystack: normalize((p.title || '') + ' ' + (p.inspired_by || '') + ' ' + (p.type || '')),
      _tokens: tokenize((p.title || '') + ' ' + (p.inspired_by || '')),
      _titleNorm: normalize(p.title || ''),
      _inspiredByNorm: normalize(p.inspired_by || ''),
    };
  }

  function bestTokenMatch(qt, pTokens) {
    let exact = -1;
    let contain = -1;
    let levBest = -1;
    let levDist = Infinity;
    for (let i = 0; i < pTokens.length; i++) {
      const pt = pTokens[i];
      if (pt === qt) { exact = i; break; }
      if (pt.indexOf(qt) !== -1 || qt.indexOf(pt) !== -1) {
        if (contain === -1) contain = i;
      }
      if (Math.abs(pt.length - qt.length) > 2) continue;
      const d = levenshtein(qt, pt);
      if (d <= 2 && d < levDist) { levDist = d; levBest = i; }
    }
    if (exact !== -1) return { score: 0, kind: 'exact' };
    if (contain !== -1) return { score: 1, kind: 'contain' };
    if (levBest !== -1) return { score: levDist, kind: 'fuzzy' };
    return null;
  }

  function scoreProduct(product, qTokens, fullQuery) {
    if (product._haystack.indexOf(fullQuery) !== -1) {
      if (product._titleNorm.indexOf(fullQuery) === 0) return 1000;
      if (product._inspiredByNorm.indexOf(fullQuery) === 0) return 950;
      return 800;
    }

    let matched = 0;
    let totalCost = 0;
    let fuzzyMatched = 0;
    let containMatched = 0;

    for (let i = 0; i < qTokens.length; i++) {
      const qt = qTokens[i];
      const m = bestTokenMatch(qt, product._tokens);
      if (!m) continue;
      matched++;
      totalCost += m.score;
      if (m.kind === 'fuzzy') fuzzyMatched++;
      else if (m.kind === 'contain') containMatched++;
    }

    if (matched === 0) return 0;
    const missing = qTokens.length - matched;
    const score = 500 - totalCost * 25 - missing * 90 + containMatched * 15 - fuzzyMatched * 5;
    return Math.max(1, score);
  }

  function fuzzySearch(catalog, query, limit) {
    const q = normalize(query);
    if (!q || !catalog || !catalog.length) return [];
    const qTokens = tokenize(q);
    if (!qTokens.length) return [];

    const scored = [];
    for (let i = 0; i < catalog.length; i++) {
      const s = scoreProduct(catalog[i], qTokens, q);
      if (s > 0) scored.push({ idx: i, score: s });
    }
    scored.sort(function (a, b) { return b.score - a.score; });
    return scored.slice(0, limit).map(function (entry) {
      const p = catalog[entry.idx];
      return {
        id: p.id,
        title: p.title,
        url: p.url,
        vendor: p.vendor,
        inspired_by: p.inspired_by,
        type: p.type,
        image: p.image,
        price_min: p.price_min,
      };
    });
  }

  function debounce(fn, delay) {
    let t;
    return function () {
      const args = arguments;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(null, args); }, delay);
    };
  }

  function formatMoney(cents) {
    if (cents == null) return '';
    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      try { return Shopify.formatMoney(cents); } catch (_) { /* fall through */ }
    }
    const currency =
      (window.Shopify && Shopify.currency && Shopify.currency.active) ||
      (window.Shopify && Shopify.shop && Shopify.shop.currency) ||
      'EUR';
    const locale = (document.documentElement && document.documentElement.lang) || 'en';
    try {
      return new Intl.NumberFormat(locale, { style: 'currency', currency: currency }).format(cents / 100);
    } catch (_) {
      return (cents / 100).toFixed(2) + ' ' + currency;
    }
  }

  function escapeHtml(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function pickVisualClass(type) {
    const t = (type || '').toLowerCase();
    if (t.indexOf('mujer') !== -1 || t.indexOf('women') !== -1 || t.indexOf('femme') !== -1) {
      return 'fuzzy-card__visual--light';
    }
    if (t.indexOf('unisex') !== -1) {
      return 'fuzzy-card__visual--gold';
    }
    return 'fuzzy-card__visual--dark';
  }

  function renderTypeahead(host, items, query, config) {
    const list = host.querySelector('[data-search-suggest-list]');
    const empty = host.querySelector('[data-search-suggest-empty]');
    const footer = host.querySelector('[data-search-suggest-footer]');
    const footerLink = host.querySelector('[data-search-suggest-footer-link]');
    list.innerHTML = '';
    if (!items.length) {
      empty.hidden = false;
      empty.textContent = 'No matches yet for "' + query + '". Try another spelling or press Enter to search.';
      footer.hidden = true;
      return;
    }
    empty.hidden = true;
    footer.hidden = false;
    footerLink.href = config.searchUrl + '?q=' + encodeURIComponent(query);
    footerLink.textContent = 'See all results for "' + query + '"';
    const frag = document.createDocumentFragment();
    for (let i = 0; i < items.length && i < 6; i++) {
      const p = items[i];
      const a = document.createElement('a');
      a.className = 'search-suggest__item';
      a.href = p.url;
      a.setAttribute('data-suggest-item', '');

      const thumb = document.createElement('div');
      thumb.className = 'search-suggest__thumb';
      if (p.image && p.image.src) {
        const img = document.createElement('img');
        img.src = p.image.src;
        img.alt = p.title || '';
        img.loading = 'lazy';
        thumb.appendChild(img);
      } else {
        const fb = document.createElement('span');
        fb.className = 'search-suggest__thumb-fallback';
        fb.textContent = ((p.title || '?').toString().slice(0, 3)).toUpperCase();
        thumb.appendChild(fb);
      }
      a.appendChild(thumb);

      const meta = document.createElement('div');
      meta.className = 'search-suggest__meta';
      if (p.inspired_by) {
        const v = document.createElement('span');
        v.className = 'search-suggest__inspiration';
        v.textContent = p.inspired_by;
        meta.appendChild(v);
      }
      const t = document.createElement('span');
      t.className = 'search-suggest__title';
      t.textContent = p.title;
      meta.appendChild(t);
      a.appendChild(meta);

      if (p.price_min != null) {
        const pr = document.createElement('span');
        pr.className = 'search-suggest__price';
        pr.textContent = formatMoney(p.price_min);
        a.appendChild(pr);
      }

      frag.appendChild(a);
    }
    list.appendChild(frag);
  }

  function attachTypeahead(input, config, catalog) {
    if (input.dataset.searchSuggestBound === '1') return;
    input.dataset.searchSuggestBound = '1';

    const field =
      input.closest('.search-drawer__field, .mobile-menu__search-field, .search-hero__field') ||
      input.parentElement;
    if (!field) return;
    if (getComputedStyle(field).position === 'static') {
      field.style.position = 'relative';
    }

    const host = document.createElement('div');
    host.className = 'search-suggest';
    host.setAttribute('data-search-suggest-host', '');
    host.setAttribute('role', 'listbox');
    host.innerHTML =
      '<div class="search-suggest__hint" data-search-suggest-empty>Type at least ' +
      config.minChars +
      ' characters…</div>' +
      '<div data-search-suggest-list></div>' +
      '<div class="search-suggest__footer" data-search-suggest-footer hidden>' +
      '<a class="search-suggest__footer-link" data-search-suggest-footer-link href="#"></a>' +
      '</div>';
    field.appendChild(host);

    let activeIndex = -1;

    const close = function () {
      host.dataset.open = 'false';
      activeIndex = -1;
      input.setAttribute('aria-expanded', 'false');
    };

    const update = debounce(function () {
      const q = input.value.trim();
      if (q.length < config.minChars) {
        close();
        return;
      }
      const items = fuzzySearch(catalog.items, q, config.limit);
      renderTypeahead(host, items, q, config);
      host.dataset.open = 'true';
      input.setAttribute('aria-expanded', 'true');
      activeIndex = -1;
    }, config.debounce);

    input.addEventListener('input', update);
    input.addEventListener('focus', function () {
      if (input.value.trim().length >= config.minChars) {
        host.dataset.open = 'true';
        input.setAttribute('aria-expanded', 'true');
      }
    });
    input.addEventListener('keydown', function (e) {
      const items = host.querySelectorAll('[data-suggest-item]');
      if (e.key === 'ArrowDown') {
        e.preventDefault();
        if (!items.length) return;
        activeIndex = Math.min(items.length - 1, activeIndex + 1);
        items.forEach(function (el, i) { el.setAttribute('aria-selected', i === activeIndex ? 'true' : 'false'); });
        if (items[activeIndex] && items[activeIndex].scrollIntoView) {
          items[activeIndex].scrollIntoView({ block: 'nearest' });
        }
      } else if (e.key === 'ArrowUp') {
        e.preventDefault();
        activeIndex = Math.max(-1, activeIndex - 1);
        items.forEach(function (el, i) { el.setAttribute('aria-selected', i === activeIndex ? 'true' : 'false'); });
      } else if (e.key === 'Enter') {
        if (activeIndex >= 0 && items[activeIndex]) {
          e.preventDefault();
          window.location.href = items[activeIndex].href;
        }
      } else if (e.key === 'Escape') {
        close();
        input.blur();
      }
    });

    document.addEventListener('click', function (e) {
      if (!host.contains(e.target) && e.target !== input) close();
    });
  }

  function initTypeaheads(config, catalog) {
    const inputs = document.querySelectorAll(
      'input[type="search"][data-search-suggest], input[name="q"][data-search-suggest]'
    );
    inputs.forEach(function (input) { attachTypeahead(input, config, catalog); });
  }

  function renderFuzzyCards(items) {
    return items
      .map(function (p) {
        const img =
          p.image && p.image.src
            ? '<div class="fuzzy-card__img-wrap"><img src="' +
              escapeHtml(p.image.src) +
              '" alt="' +
              escapeHtml(p.title) +
              '" loading="lazy"></div>'
            : '';
        const visual = pickVisualClass(p.type);
        const meta = [
          p.type ? '<span>' + escapeHtml(p.type) + '</span>' : '',
          p.inspired_by ? '<span>' + escapeHtml(p.inspired_by) + '</span>' : '',
        ]
          .filter(Boolean)
          .join('');
        return (
          '<article class="fuzzy-card">' +
          '<a class="fuzzy-card__link" href="' + escapeHtml(p.url) + '">' +
          '<div class="fuzzy-card__visual ' + visual + '">' + img + '</div>' +
          (meta ? '<div class="fuzzy-card__meta">' + meta + '</div>' : '') +
          '<h3 class="fuzzy-card__name">' + escapeHtml(p.title) + '</h3>' +
          (p.price_min != null
            ? '<div class="fuzzy-card__price">' + escapeHtml(formatMoney(p.price_min)) + '</div>'
            : '') +
          '</a>' +
          '</article>'
        );
      })
      .join('');
  }

  function enhanceSearchPage(config, catalog) {
    const containers = document.querySelectorAll('[data-search-fuzzy]');
    if (!containers.length) return;

    const params = new URLSearchParams(window.location.search);
    const term = (params.get('q') || '').trim();
    if (!term) return;

    const nativeEmpty = document.querySelector('[data-search-empty]');
    const nativeCountEl = document.querySelector('[data-search-native-count]');
    const nativeCount = nativeCountEl ? parseInt(nativeCountEl.textContent || '0', 10) || 0 : null;

    const items = fuzzySearch(catalog, term, config.limit);
    if (!items.length) return;

    const top = items[0];
    const topTerm = top.inspired_by ? top.inspired_by : (top.title || term);
    const showDidYouMean = normalize(topTerm) !== normalize(term);

    containers.forEach(function (host) {
      host.hidden = false;

      const notice = showDidYouMean
        ? '<div class="fuzzy-results__notice">' +
          '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" aria-hidden="true"><circle cx="12" cy="12" r="10"/><path d="M12 8v4M12 16h.01"/></svg>' +
          '<span>We couldn\'t find <em>' + escapeHtml(term) + '</em> exactly. Did you mean <a href="' +
          config.searchUrl + '?q=' + encodeURIComponent(topTerm) + '">' + escapeHtml(topTerm) + '</a>?</span>' +
          '</div>'
        : '';

      const heading =
        nativeCount === 0
          ? 'Close matches for "' + escapeHtml(term) + '"'
          : 'Other close matches';
      const subheading =
        'Showing products that may match even if the spelling differs.';

      host.innerHTML =
        notice +
        '<div class="fuzzy-results__inner">' +
        '<h2 class="fuzzy-results__heading">' + heading + '</h2>' +
        '<p class="fuzzy-results__subheading">' + subheading + '</p>' +
        '<div class="fuzzy-results__grid">' + renderFuzzyCards(items) + '</div>' +
        '</div>';

      if (nativeCount === 0 && nativeEmpty) {
        nativeEmpty.hidden = true;
      }
    });
  }

  function init() {
    const config = readConfig();
    if (!config) return;
    const catalog = { items: [] };
    initTypeaheads(config, catalog);
    loadCatalog(config.catalogUrl).then(function (items) {
      if (!items || !items.length) return;
      catalog.items = items;
      inputsWithText().forEach(function (input) {
        input.dispatchEvent(new Event('input'));
      });
      enhanceSearchPage(config, items);
    });
  }

  function inputsWithText() {
    return Array.prototype.filter.call(
      document.querySelectorAll('input[data-search-suggest]'),
      function (input) { return document.activeElement === input && input.value.trim(); }
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["shipping-promise"] && !Shopify.designMode) return;
  try {
    (function () {
    var box = document.querySelector('[data-shipping-promise]');
    if (!box) return;

    var status = box.querySelector('[data-shipping-promise-status]');
    var threshold = parseInt(box.getAttribute('data-threshold-cents'), 10);
    var cartTotal = parseInt(box.getAttribute('data-cart-total'), 10) || 0;
    var price = parseInt(box.getAttribute('data-variant-price'), 10) || 0;

    function formatMoney(cents) {
      var lang = (document.documentElement && document.documentElement.lang) || 'es';
      try {
        return '€' + new Intl.NumberFormat(lang, { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(cents / 100);
      } catch (e) {
        return '€' + (cents / 100).toFixed(2).replace('.', ',');
      }
    }

    function quantity() {
      var input = document.getElementById('pd-qty');
      var q = input ? parseInt(input.value, 10) : 1;
      return isNaN(q) || q < 1 ? 1 : q;
    }

    function render() {
      if (!status || isNaN(threshold)) return;
      var remaining = threshold - (cartTotal + price * quantity());
      var free = remaining <= 0;
      box.classList.toggle('is-free', free);
      status.textContent = free
        ? box.getAttribute('data-free-text')
        : (box.getAttribute('data-remaining-template') || '').replace('%%AMOUNT%%', formatMoney(remaining));
    }

    document.addEventListener('click', function (event) {
      var chip = event.target.closest('.pd-size-chip');
      if (!chip || chip.getAttribute('aria-disabled') === 'true') return;
      price = parseInt(chip.getAttribute('data-variant-price'), 10) || price;
      render();
    });

    document.addEventListener('input', function (event) {
      if (event.target && event.target.id === 'pd-qty') render();
    });

    document.addEventListener('click', function (event) {
      if (event.target.closest('[data-quantity-minus], [data-quantity-plus]')) setTimeout(render, 0);
    });

    document.addEventListener('cart:change', function (event) {
      var cart = event.detail && event.detail.cart;
      if (!cart || typeof cart.total_price !== 'number') return;
      cartTotal = cart.total_price;
      render();
    });

    render();
  })();
  } catch(e) { console.error(e); }
})();

})();
